import { render, staticRenderFns } from "./comp6-1.vue?vue&type=template&id=ef4e8022&scoped=true"
import script from "./comp6-1.vue?vue&type=script&lang=ts"
export * from "./comp6-1.vue?vue&type=script&lang=ts"
import style0 from "./comp6-1.vue?vue&type=style&index=0&id=ef4e8022&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4e8022",
  null
  
)

export default component.exports